import { useQuery } from '@tanstack/react-query';

import { env } from '../utils/env';

export interface AgesResult {
  ages: Age[];
}

export interface Age {
  age_int: number;
  age_display: string;
}

export const useAges = () => {
  const { data, error, isLoading } = useQuery<AgesResult>({
    queryKey: ['ages'],
    queryFn: () => fetch(`${env.API_URL}/ages`).then((res) => res.json()),
  });

  return {
    ages: data?.ages.sort((a, b) => a.age_int - b.age_int) ?? [],
    error,
    isLoading,
  };
};
